import React from 'react';
import PropTypes from 'prop-types';
import { TopToolbar, ListButton } from 'react-admin';

const ContentActions = ({ basePath, data }) => (
  <TopToolbar>
    <ListButton basePath={basePath} record={data} />
  </TopToolbar>
);

ContentActions.propTypes = {
  basePath: PropTypes.string,
  data: PropTypes.shape({}),
};

ContentActions.defaultProps = {
  basePath: '',
  data: {},
};

export default ContentActions;
